'use client'

import Image from 'next/image'
import { useState } from 'react'
import { ImagePlaceholder } from '@/components/common/ImagePlaceholder'

interface ProductImageProps {
  src: string
  alt: string
  priority?: boolean
  fill?: boolean
  sizes?: string
  className?: string
}

/**
 * ProductImage component with fallback to placeholder on error
 * Client component to handle image load errors
 */
export function ProductImage({
  src,
  alt,
  priority,
  fill,
  sizes,
  className,
}: ProductImageProps) {
  const [hasError, setHasError] = useState(false)

  const handleError = () => {
    if (!hasError) {
      setHasError(true)
    }
  }

  // Show placeholder if error or no src
  if (hasError || !src || src === '/placeholder.svg') {
    return <ImagePlaceholder />
  }

  return (
    <Image
      src={src}
      alt={alt}
      fill={fill}
      priority={priority}
      sizes={sizes}
      className={className}
      onError={handleError}
    />
  )
}
